<div class="rounded-xl border p-4" [ngClass]="alertType()">
    <div class="flex items-center gap-3">
        <div class="-mt-0.5">
            @if(alertType() === 'warning') {
                <svg class="size-6" fill="currentColor" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                    <path clip-rule="evenodd" d="M6.701 2.25c.577-1 2.02-1 2.598 0l5.196 9a1.5 1.5 0 0 1-1.299 2.25H2.804a1.5 1.5 0 0 1-1.3-2.25l5.197-9ZM8 4a.75.75 0 0 1 .75.75v3a.75.75 0 1 1-1.5 0v-3A.75.75 0 0 1 8 4Zm0 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" fill-rule="evenodd" />
                </svg>
            }
            @if(alertType() === 'error') {
                <svg class="size-6" fill="currentColor" svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                    <path clip-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Zm2.78-4.22a.75.75 0 0 1-1.06 0L8 9.06l-1.72 1.72a.75.75 0 1 1-1.06-1.06L6.94 8 5.22 6.28a.75.75 0 0 1 1.06-1.06L8 6.94l1.72-1.72a.75.75 0 1 1 1.06 1.06L9.06 8l1.72 1.72a.75.75 0 0 1 0 1.06Z" fill-rule="evenodd" />
                </svg>
            }
            @if(alertType() === 'success') {
                <svg class="size-6" fill="currentColor" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                    <path clip-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Zm3.844-8.791a.75.75 0 0 0-1.188-.918l-3.7 4.79-1.649-1.833a.75.75 0 1 0-1.114 1.004l2.25 2.5a.75.75 0 0 0 1.15-.043l4.25-5.5Z" fill-rule="evenodd" />
                </svg>
            }
        </div>
        <div>
            <h4 class="mb-1 text-sm font-semibold text-gray-800"> {{ title() }} </h4>
            <p class="text-sm text-gray-500">{{ message() }} </p>
        </div>
    </div>
</div>
